import React from 'react'
import { styled } from '@mui/material/styles'
import InfoIcon from '@mui/icons-material/Info'
import { Typography } from '@mui/material'

const PREFIX = 'Infobox'

const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  text: `${PREFIX}-text`
}

const Root = styled('div')(({ theme: { spacing, shape, palette } }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    padding: spacing(2),
    borderRadius: shape.borderRadius,
    backgroundColor: palette.grey[100]
  },

  [`& .${classes.icon}`]: {
    color: palette.grey[600]
  },

  [`& .${classes.text}`]: {
    marginLeft: spacing(2),
    alignSelf: 'center',
    flex: 1
  }
}))

type InfoboxPropTypes = {
  text: string
}

const Infobox: React.FC<InfoboxPropTypes> = ({ text }) => {
  return (
    <Root className={classes.root}>
      <InfoIcon className={classes.icon} />
      <Typography variant="body2" className={classes.text}>
        {text}
      </Typography>
    </Root>
  )
}

export default Infobox
